module.exports = __webpack_public_path__ + "static/images/banner1_ca29f2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/banner1.png
// module id = 220
// module chunks = 1